import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=4d2bf004&scoped=true&"
import script from "./entry.vue?vue&type=script&lang=js&"
export * from "./entry.vue?vue&type=script&lang=js&"
import style0 from "./entry.vue?vue&type=style&index=0&id=4d2bf004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2bf004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2bf004')) {
      api.createRecord('4d2bf004', component.options)
    } else {
      api.reload('4d2bf004', component.options)
    }
    module.hot.accept("./entry.vue?vue&type=template&id=4d2bf004&scoped=true&", function () {
      api.rerender('4d2bf004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry.vue"
export default component.exports